  import styled from "styled-components";

  export const FlorenzToogle = styled.div`
    border: 2px solid var(--base-White-I, #FFFFFF);
    height: 36px;
    border-radius: 56px;
    display: flex;
    height: 100%;
    width: 100%;
    font-family: 'Nunito Sans';
    height: 31px;
    .tab {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      padding: 0 20px;
      font-size: 15px;
      color: #1F1F52;
      white-space: nowrap;
    }
    .active-tab {
      background-color: #6C6BF5;
      color: #FFFFFF;
      border-radius: 20.15px;
      font-size: 15px;
      box-shadow: 0px 0px 4.03px 0px #AEADFB;
    }
  `